module.exports = __webpack_public_path__ + "img/海洋.5f479e8f.png";